import { Helmet } from 'react-helmet-async';

export function SEO({ title, description, keywords, canonical, type = 'website', image }) {
  const siteName = 'DoggoHub';
  const fullTitle = title ? `${title} | ${siteName}` : `${siteName} - Find Your Perfect Dog`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description || 'DoggoHub is your trusted dog marketplace. Browse dogs for sale, explore breeds, and find the perfect companion.'} />
      {keywords && <meta name="keywords" content={keywords} />}
      {canonical && <link rel="canonical" href={canonical} />}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description || 'Find your perfect dog on DoggoHub.'} />
      <meta property="og:type" content={type} />
      {image && <meta property="og:image" content={image} />}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description || 'Find your perfect dog on DoggoHub.'} />
    </Helmet>
  );
}
